import { watch } from 'vue'
import { Product } from '../../models'
import { useTypedItineraryStore } from '../../stores/typed'
import api from '../../utils/api'
import { logErrorOnSentry } from '../../utils/errorReportingUtils'
import { useShared } from '../vueHelpers'

export enum SelfServePublishStages {
  ITINERARY_SETUP = 'itinerary_setup',
  ITINERARY_PREVIEW = 'itinerary_preview',
  PENDING_LAUNCH = 'pending_launch',
}

export function useSelfServePublishStages({
  stage,
  isProduct,
  componentInfo,
}: {
  stage: SelfServePublishStages
  isProduct: boolean
  componentInfo: ReturnType<typeof useShared>['componentInfo']
}) {
  const store = useTypedItineraryStore<Product>()

  watch(
    () => store.data,
    async (current, prev) => {
      if (!prev && current) {
        try {
          const params = isProduct ? { product_id: current.id } : { itinerary_request_id: store.itineraryRequestId }

          await api.put(`/api/hero/products/publish_stage`, {
            stage: stage,
            ...params,
          })
        } catch (error) {
          logErrorOnSentry(error, componentInfo)
        }
      }
    },
    { immediate: true },
  )
}

export function useAssociateProductToChatroom() {
  const store = useTypedItineraryStore<Product>()
  const componentInfo = useShared()

  watch(
    () => store.data,
    async (current, prev) => {
      if (!prev && current) {
        try {
          const response = await api.post(`/api/chatrooms/associate_product_to_chatroom`, { product_id: current.id })
          store.chatroomId = response.data.chatroomId ?? null
        } catch (error) {
          logErrorOnSentry(error, componentInfo)
        }
      }
    },
    { immediate: true },
  )
}
